import React from 'react';

interface Props {
  type: 'parent' | 'child';
  selectedAddress: string;
  addressList: Address[];
  toggle: (address: Address) => void;
  isOpen: boolean;
  close: () => void;
}

export default function AddressSelector({
  addressList,
  toggle,
  selectedAddress,
  close,
  isOpen,
}: Props) {
  return (
    <div
      className="address-select-modal-wrapper"
      style={{display: isOpen ? 'flex' : 'none'}}>
      <div className="address-select-container">
        <div className="address-select-modal-header">
          <span
            className="gray-close-icon"
            onClick={() => close()}
            style={{cursor: 'pointer'}}>
            &nbsp;
          </span>
        </div>
        <div className="address-selector-wrapper">
          <ul className="address-select-modal-body">
            {addressList.map(address => {
              return (
                <li
                  className={`address-item ${
                    selectedAddress === address.address ? 'active' : ''
                  }`}
                  key={`address_list_item_${address.id}`}
                  onClick={() => toggle(address)}>
                  {address.address}
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </div>
  );
}
